import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _81fa3292 = () => interopDefault(import('../pages/author/index.vue' /* webpackChunkName: "pages/author/index" */))
const _4578cc94 = () => interopDefault(import('../pages/discussion/index.vue' /* webpackChunkName: "pages/discussion/index" */))
const _1afcc78c = () => interopDefault(import('../pages/discussion_tags/index.vue' /* webpackChunkName: "pages/discussion_tags/index" */))
const _94d3e676 = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _56faca3c = () => interopDefault(import('../pages/gallery/index.vue' /* webpackChunkName: "pages/gallery/index" */))
const _fb3830dc = () => interopDefault(import('../pages/gallery_tags/index.vue' /* webpackChunkName: "pages/gallery_tags/index" */))
const _36fa175d = () => interopDefault(import('../pages/inquire/index.vue' /* webpackChunkName: "pages/inquire/index" */))
const _9a7c969e = () => interopDefault(import('../pages/message/index.vue' /* webpackChunkName: "pages/message/index" */))
const _5bff728a = () => interopDefault(import('../pages/new/index.vue' /* webpackChunkName: "pages/new/index" */))
const _435b5432 = () => interopDefault(import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */))
const _603258bc = () => interopDefault(import('../pages/releaseWork/index.vue' /* webpackChunkName: "pages/releaseWork/index" */))
const _26891b67 = () => interopDefault(import('../pages/setup/index.vue' /* webpackChunkName: "pages/setup/index" */))
const _421e548a = () => interopDefault(import('../pages/tutorial/index.vue' /* webpackChunkName: "pages/tutorial/index" */))
const _7e3c6966 = () => interopDefault(import('../pages/app/AccountDeletionAgreement.vue' /* webpackChunkName: "pages/app/AccountDeletionAgreement" */))
const _0f5e19fb = () => interopDefault(import('../pages/app/deleteAccount.vue' /* webpackChunkName: "pages/app/deleteAccount" */))
const _046826b3 = () => interopDefault(import('../pages/app/PrivacyPolicy.vue' /* webpackChunkName: "pages/app/PrivacyPolicy" */))
const _a6a71050 = () => interopDefault(import('../pages/app/UserAgreement.vue' /* webpackChunkName: "pages/app/UserAgreement" */))
const _c670d94e = () => interopDefault(import('../pages/app/XCoinsAgreement.vue' /* webpackChunkName: "pages/app/XCoinsAgreement" */))
const _45c11f97 = () => interopDefault(import('../pages/app/xppen-csae.vue' /* webpackChunkName: "pages/app/xppen-csae" */))
const _3a181eca = () => interopDefault(import('../pages/discussion/editor.vue' /* webpackChunkName: "pages/discussion/editor" */))
const _04e8517c = () => interopDefault(import('../pages/document/about.vue' /* webpackChunkName: "pages/document/about" */))
const _031e4eff = () => interopDefault(import('../pages/document/cookie.vue' /* webpackChunkName: "pages/document/cookie" */))
const _39c771e2 = () => interopDefault(import('../pages/document/privacyPolicy.vue' /* webpackChunkName: "pages/document/privacyPolicy" */))
const _431c9a14 = () => interopDefault(import('../pages/document/termsConditions.vue' /* webpackChunkName: "pages/document/termsConditions" */))
const _e0905422 = () => interopDefault(import('../pages/events/activity-18th-Anniversary.vue' /* webpackChunkName: "pages/events/activity-18th-Anniversary" */))
const _e80ddd00 = () => interopDefault(import('../pages/events/activity-activi_draw_en.vue' /* webpackChunkName: "pages/events/activity-activi_draw_en" */))
const _43806604 = () => interopDefault(import('../pages/events/activity-anniversary_contest.vue' /* webpackChunkName: "pages/events/activity-anniversary_contest" */))
const _56ccd3fc = () => interopDefault(import('../pages/events/activity-anniversary_contest2022.vue' /* webpackChunkName: "pages/events/activity-anniversary_contest2022" */))
const _7ca996d4 = () => interopDefault(import('../pages/events/activity-Christmas_contest.vue' /* webpackChunkName: "pages/events/activity-Christmas_contest" */))
const _3e2afce2 = () => interopDefault(import('../pages/events/activity-comic_contest.vue' /* webpackChunkName: "pages/events/activity-comic_contest" */))
const _2aefb47c = () => interopDefault(import('../pages/events/activity-drawing_activi.vue' /* webpackChunkName: "pages/events/activity-drawing_activi" */))
const _08123b61 = () => interopDefault(import('../pages/events/activity-emoticons_contest.vue' /* webpackChunkName: "pages/events/activity-emoticons_contest" */))
const _396f0b3c = () => interopDefault(import('../pages/events/activity-fenix-summer-racing.vue' /* webpackChunkName: "pages/events/activity-fenix-summer-racing" */))
const _1e8c8d78 = () => interopDefault(import('../pages/events/activity-find_x_contest.vue' /* webpackChunkName: "pages/events/activity-find_x_contest" */))
const _03468369 = () => interopDefault(import('../pages/events/activity-gift-idea-challenge.vue' /* webpackChunkName: "pages/events/activity-gift-idea-challenge" */))
const _2c2c0501 = () => interopDefault(import('../pages/events/activity-halloween_contest.vue' /* webpackChunkName: "pages/events/activity-halloween_contest" */))
const _45104b31 = () => interopDefault(import('../pages/events/activity-new_user_sign.vue' /* webpackChunkName: "pages/events/activity-new_user_sign" */))
const _487882ba = () => interopDefault(import('../pages/events/activity-painting-contest_kr.vue' /* webpackChunkName: "pages/events/activity-painting-contest_kr" */))
const _0c0975a0 = () => interopDefault(import('../pages/events/activity-Painting23_kr.vue' /* webpackChunkName: "pages/events/activity-Painting23_kr" */))
const _59b75084 = () => interopDefault(import('../pages/events/activity-video_activity.vue' /* webpackChunkName: "pages/events/activity-video_activity" */))
const _47d6e65c = () => interopDefault(import('../pages/events/activity-xfans_animation.vue' /* webpackChunkName: "pages/events/activity-xfans_animation" */))
const _cf8c9c14 = () => interopDefault(import('../pages/events/activity-xfans_drawing.vue' /* webpackChunkName: "pages/events/activity-xfans_drawing" */))
const _124d6eac = () => interopDefault(import('../pages/events/activity-xfans_joy.vue' /* webpackChunkName: "pages/events/activity-xfans_joy" */))
const _51ba93d3 = () => interopDefault(import('../pages/events/activity-xppen-creative-contest.vue' /* webpackChunkName: "pages/events/activity-xppen-creative-contest" */))
const _4ded01b6 = () => interopDefault(import('../pages/events/activity-xppen-geeks-unite.vue' /* webpackChunkName: "pages/events/activity-xppen-geeks-unite" */))
const _24e38073 = () => interopDefault(import('../pages/events/activity-xppen-le-petit-prince.vue' /* webpackChunkName: "pages/events/activity-xppen-le-petit-prince" */))
const _60644597 = () => interopDefault(import('../pages/events/activity-xppen-the-little-prince.vue' /* webpackChunkName: "pages/events/activity-xppen-the-little-prince" */))
const _1d42b1b8 = () => interopDefault(import('../pages/events/co-create-with-pubgm-pdp.vue' /* webpackChunkName: "pages/events/co-create-with-pubgm-pdp" */))
const _62fb9cbe = () => interopDefault(import('../pages/events/connect-magic-into-one-world.vue' /* webpackChunkName: "pages/events/connect-magic-into-one-world" */))
const _99f62c92 = () => interopDefault(import('../pages/events/daily-doodle-zoo.vue' /* webpackChunkName: "pages/events/daily-doodle-zoo" */))
const _6c13c6fd = () => interopDefault(import('../pages/events/doodle-contest.vue' /* webpackChunkName: "pages/events/doodle-contest" */))
const _604be455 = () => interopDefault(import('../pages/events/future-me.vue' /* webpackChunkName: "pages/events/future-me" */))
const _20bde562 = () => interopDefault(import('../pages/events/Future-X-Program.vue' /* webpackChunkName: "pages/events/Future-X-Program" */))
const _3a6d695b = () => interopDefault(import('../pages/events/global-art-toy-design-contest.vue' /* webpackChunkName: "pages/events/global-art-toy-design-contest" */))
const _0db46601 = () => interopDefault(import('../pages/events/Illustration-contest_jp.vue' /* webpackChunkName: "pages/events/Illustration-contest_jp" */))
const _6e795c5b = () => interopDefault(import('../pages/events/micro-view-macro-imagination-drawing-contest.vue' /* webpackChunkName: "pages/events/micro-view-macro-imagination-drawing-contest" */))
const _94989c68 = () => interopDefault(import('../pages/events/monster-doodle-adventure.vue' /* webpackChunkName: "pages/events/monster-doodle-adventure" */))
const _5b1a958b = () => interopDefault(import('../pages/events/nature-contest.vue' /* webpackChunkName: "pages/events/nature-contest" */))
const _e95718a6 = () => interopDefault(import('../pages/events/painting-contest_JP.vue' /* webpackChunkName: "pages/events/painting-contest_JP" */))
const _e5b50964 = () => interopDefault(import('../pages/events/painting-contest_KR.vue' /* webpackChunkName: "pages/events/painting-contest_KR" */))
const _7e5f2982 = () => interopDefault(import('../pages/events/painting-contest_KR_2025.vue' /* webpackChunkName: "pages/events/painting-contest_KR_2025" */))
const _7d4a2637 = () => interopDefault(import('../pages/events/Petsona-Challenge.vue' /* webpackChunkName: "pages/events/Petsona-Challenge" */))
const _0ad2c014 = () => interopDefault(import('../pages/events/pubgm-pdp-contest-rules.vue' /* webpackChunkName: "pages/events/pubgm-pdp-contest-rules" */))
const _8f0e1a94 = () => interopDefault(import('../pages/events/riders-of-the-waterworld.vue' /* webpackChunkName: "pages/events/riders-of-the-waterworld" */))
const _480a31f1 = () => interopDefault(import('../pages/events/spring-contest.vue' /* webpackChunkName: "pages/events/spring-contest" */))
const _884c4f36 = () => interopDefault(import('../pages/events/Strange-Little-Things-Drawing-Challenge.vue' /* webpackChunkName: "pages/events/Strange-Little-Things-Drawing-Challenge" */))
const _2f87bc8a = () => interopDefault(import('../pages/events/the-great-t-shirt-challenge.vue' /* webpackChunkName: "pages/events/the-great-t-shirt-challenge" */))
const _11d4fc22 = () => interopDefault(import('../pages/events/the-journey-of-miracles.vue' /* webpackChunkName: "pages/events/the-journey-of-miracles" */))
const _52a3b09c = () => interopDefault(import('../pages/events/the-magic-mirror-journey-begins.vue' /* webpackChunkName: "pages/events/the-magic-mirror-journey-begins" */))
const _08f9e972 = () => interopDefault(import('../pages/events/vibrant-city-challenge.vue' /* webpackChunkName: "pages/events/vibrant-city-challenge" */))
const _7774bdfa = () => interopDefault(import('../pages/events/vibrant-city-challenge-pt.vue' /* webpackChunkName: "pages/events/vibrant-city-challenge-pt" */))
const _19ced761 = () => interopDefault(import('../pages/preview/work.vue' /* webpackChunkName: "pages/preview/work" */))
const _5b1e9e96 = () => interopDefault(import('../pages/setup/blacklist/index.vue' /* webpackChunkName: "pages/setup/blacklist/index" */))
const _df5477fa = () => interopDefault(import('../pages/setup/feedback/index.vue' /* webpackChunkName: "pages/setup/feedback/index" */))
const _1d51d8a4 = () => interopDefault(import('../pages/setup/inviteFriends/index.vue' /* webpackChunkName: "pages/setup/inviteFriends/index" */))
const _128992dc = () => interopDefault(import('../pages/setup/thirdBinding/index.vue' /* webpackChunkName: "pages/setup/thirdBinding/index" */))
const _acd4440c = () => interopDefault(import('../pages/tutorial/details.vue' /* webpackChunkName: "pages/tutorial/details" */))
const _368841ba = () => interopDefault(import('../pages/user/gallery/index.vue' /* webpackChunkName: "pages/user/gallery/index" */))
const _045966f5 = () => interopDefault(import('../pages/user/xcoins.vue' /* webpackChunkName: "pages/user/xcoins" */))
const _154605a2 = () => interopDefault(import('../pages/xcoins/exchange.vue' /* webpackChunkName: "pages/xcoins/exchange" */))
const _cbbaae26 = () => interopDefault(import('../pages/xcoins/lottery.vue' /* webpackChunkName: "pages/xcoins/lottery" */))
const _001ec91e = () => interopDefault(import('../pages/xcoins/orderConfirm.vue' /* webpackChunkName: "pages/xcoins/orderConfirm" */))
const _3727700c = () => interopDefault(import('../pages/xcoins/xcoinRules.vue' /* webpackChunkName: "pages/xcoins/xcoinRules" */))
const _4c22feec = () => interopDefault(import('../pages/xcoins/xcoinTerms.vue' /* webpackChunkName: "pages/xcoins/xcoinTerms" */))
const _9307e3b6 = () => interopDefault(import('../pages/xcoins/goods/_id.vue' /* webpackChunkName: "pages/xcoins/goods/_id" */))
const _46ff2854 = () => interopDefault(import('../pages/xcoins/result/_id.vue' /* webpackChunkName: "pages/xcoins/result/_id" */))
const _4038e3fc = () => interopDefault(import('../pages/discussion/_id.vue' /* webpackChunkName: "pages/discussion/_id" */))
const _2c23a8b8 = () => interopDefault(import('../pages/gallery/_id.vue' /* webpackChunkName: "pages/gallery/_id" */))
const _78fc8f72 = () => interopDefault(import('../pages/new/_id.vue' /* webpackChunkName: "pages/new/_id" */))
const _21db855f = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _2074cbb9 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/author",
    component: _81fa3292,
    name: "author"
  }, {
    path: "/discussion",
    component: _4578cc94,
    name: "discussion"
  }, {
    path: "/discussion_tags",
    component: _1afcc78c,
    name: "discussion_tags"
  }, {
    path: "/events",
    component: _94d3e676,
    name: "events"
  }, {
    path: "/gallery",
    component: _56faca3c,
    name: "gallery"
  }, {
    path: "/gallery_tags",
    component: _fb3830dc,
    name: "gallery_tags"
  }, {
    path: "/inquire",
    component: _36fa175d,
    name: "inquire"
  }, {
    path: "/message",
    component: _9a7c969e,
    name: "message"
  }, {
    path: "/new",
    component: _5bff728a,
    name: "new"
  }, {
    path: "/partner",
    component: _435b5432,
    name: "partner"
  }, {
    path: "/releaseWork",
    component: _603258bc,
    name: "releaseWork"
  }, {
    path: "/setup",
    component: _26891b67,
    name: "setup"
  }, {
    path: "/tutorial",
    component: _421e548a,
    name: "tutorial"
  }, {
    path: "/app/AccountDeletionAgreement",
    component: _7e3c6966,
    name: "app-AccountDeletionAgreement"
  }, {
    path: "/app/deleteAccount",
    component: _0f5e19fb,
    name: "app-deleteAccount"
  }, {
    path: "/app/PrivacyPolicy",
    component: _046826b3,
    name: "app-PrivacyPolicy"
  }, {
    path: "/app/UserAgreement",
    component: _a6a71050,
    name: "app-UserAgreement"
  }, {
    path: "/app/XCoinsAgreement",
    component: _c670d94e,
    name: "app-XCoinsAgreement"
  }, {
    path: "/app/xppen-csae",
    component: _45c11f97,
    name: "app-xppen-csae"
  }, {
    path: "/discussion/editor",
    component: _3a181eca,
    name: "discussion-editor"
  }, {
    path: "/document/about",
    component: _04e8517c,
    name: "document-about"
  }, {
    path: "/document/cookie",
    component: _031e4eff,
    name: "document-cookie"
  }, {
    path: "/document/privacyPolicy",
    component: _39c771e2,
    name: "document-privacyPolicy"
  }, {
    path: "/document/termsConditions",
    component: _431c9a14,
    name: "document-termsConditions"
  }, {
    path: "/events/activity-18th-Anniversary",
    component: _e0905422,
    name: "events-activity-18th-Anniversary"
  }, {
    path: "/events/activity-activi_draw_en",
    component: _e80ddd00,
    name: "events-activity-activi_draw_en"
  }, {
    path: "/events/activity-anniversary_contest",
    component: _43806604,
    name: "events-activity-anniversary_contest"
  }, {
    path: "/events/activity-anniversary_contest2022",
    component: _56ccd3fc,
    name: "events-activity-anniversary_contest2022"
  }, {
    path: "/events/activity-Christmas_contest",
    component: _7ca996d4,
    name: "events-activity-Christmas_contest"
  }, {
    path: "/events/activity-comic_contest",
    component: _3e2afce2,
    name: "events-activity-comic_contest"
  }, {
    path: "/events/activity-drawing_activi",
    component: _2aefb47c,
    name: "events-activity-drawing_activi"
  }, {
    path: "/events/activity-emoticons_contest",
    component: _08123b61,
    name: "events-activity-emoticons_contest"
  }, {
    path: "/events/activity-fenix-summer-racing",
    component: _396f0b3c,
    name: "events-activity-fenix-summer-racing"
  }, {
    path: "/events/activity-find_x_contest",
    component: _1e8c8d78,
    name: "events-activity-find_x_contest"
  }, {
    path: "/events/activity-gift-idea-challenge",
    component: _03468369,
    name: "events-activity-gift-idea-challenge"
  }, {
    path: "/events/activity-halloween_contest",
    component: _2c2c0501,
    name: "events-activity-halloween_contest"
  }, {
    path: "/events/activity-new_user_sign",
    component: _45104b31,
    name: "events-activity-new_user_sign"
  }, {
    path: "/events/activity-painting-contest_kr",
    component: _487882ba,
    name: "events-activity-painting-contest_kr"
  }, {
    path: "/events/activity-Painting23_kr",
    component: _0c0975a0,
    name: "events-activity-Painting23_kr"
  }, {
    path: "/events/activity-video_activity",
    component: _59b75084,
    name: "events-activity-video_activity"
  }, {
    path: "/events/activity-xfans_animation",
    component: _47d6e65c,
    name: "events-activity-xfans_animation"
  }, {
    path: "/events/activity-xfans_drawing",
    component: _cf8c9c14,
    name: "events-activity-xfans_drawing"
  }, {
    path: "/events/activity-xfans_joy",
    component: _124d6eac,
    name: "events-activity-xfans_joy"
  }, {
    path: "/events/activity-xppen-creative-contest",
    component: _51ba93d3,
    name: "events-activity-xppen-creative-contest"
  }, {
    path: "/events/activity-xppen-geeks-unite",
    component: _4ded01b6,
    name: "events-activity-xppen-geeks-unite"
  }, {
    path: "/events/activity-xppen-le-petit-prince",
    component: _24e38073,
    name: "events-activity-xppen-le-petit-prince"
  }, {
    path: "/events/activity-xppen-the-little-prince",
    component: _60644597,
    name: "events-activity-xppen-the-little-prince"
  }, {
    path: "/events/co-create-with-pubgm-pdp",
    component: _1d42b1b8,
    name: "events-co-create-with-pubgm-pdp"
  }, {
    path: "/events/connect-magic-into-one-world",
    component: _62fb9cbe,
    name: "events-connect-magic-into-one-world"
  }, {
    path: "/events/daily-doodle-zoo",
    component: _99f62c92,
    name: "events-daily-doodle-zoo"
  }, {
    path: "/events/doodle-contest",
    component: _6c13c6fd,
    name: "events-doodle-contest"
  }, {
    path: "/events/future-me",
    component: _604be455,
    name: "events-future-me"
  }, {
    path: "/events/Future-X-Program",
    component: _20bde562,
    name: "events-Future-X-Program"
  }, {
    path: "/events/global-art-toy-design-contest",
    component: _3a6d695b,
    name: "events-global-art-toy-design-contest"
  }, {
    path: "/events/Illustration-contest_jp",
    component: _0db46601,
    name: "events-Illustration-contest_jp"
  }, {
    path: "/events/micro-view-macro-imagination-drawing-contest",
    component: _6e795c5b,
    name: "events-micro-view-macro-imagination-drawing-contest"
  }, {
    path: "/events/monster-doodle-adventure",
    component: _94989c68,
    name: "events-monster-doodle-adventure"
  }, {
    path: "/events/nature-contest",
    component: _5b1a958b,
    name: "events-nature-contest"
  }, {
    path: "/events/painting-contest_JP",
    component: _e95718a6,
    name: "events-painting-contest_JP"
  }, {
    path: "/events/painting-contest_KR",
    component: _e5b50964,
    name: "events-painting-contest_KR"
  }, {
    path: "/events/painting-contest_KR_2025",
    component: _7e5f2982,
    name: "events-painting-contest_KR_2025"
  }, {
    path: "/events/Petsona-Challenge",
    component: _7d4a2637,
    name: "events-Petsona-Challenge"
  }, {
    path: "/events/pubgm-pdp-contest-rules",
    component: _0ad2c014,
    name: "events-pubgm-pdp-contest-rules"
  }, {
    path: "/events/riders-of-the-waterworld",
    component: _8f0e1a94,
    name: "events-riders-of-the-waterworld"
  }, {
    path: "/events/spring-contest",
    component: _480a31f1,
    name: "events-spring-contest"
  }, {
    path: "/events/Strange-Little-Things-Drawing-Challenge",
    component: _884c4f36,
    name: "events-Strange-Little-Things-Drawing-Challenge"
  }, {
    path: "/events/the-great-t-shirt-challenge",
    component: _2f87bc8a,
    name: "events-the-great-t-shirt-challenge"
  }, {
    path: "/events/the-journey-of-miracles",
    component: _11d4fc22,
    name: "events-the-journey-of-miracles"
  }, {
    path: "/events/the-magic-mirror-journey-begins",
    component: _52a3b09c,
    name: "events-the-magic-mirror-journey-begins"
  }, {
    path: "/events/vibrant-city-challenge",
    component: _08f9e972,
    name: "events-vibrant-city-challenge"
  }, {
    path: "/events/vibrant-city-challenge-pt",
    component: _7774bdfa,
    name: "events-vibrant-city-challenge-pt"
  }, {
    path: "/preview/work",
    component: _19ced761,
    name: "preview-work"
  }, {
    path: "/setup/blacklist",
    component: _5b1e9e96,
    name: "setup-blacklist"
  }, {
    path: "/setup/feedback",
    component: _df5477fa,
    name: "setup-feedback"
  }, {
    path: "/setup/inviteFriends",
    component: _1d51d8a4,
    name: "setup-inviteFriends"
  }, {
    path: "/setup/thirdBinding",
    component: _128992dc,
    name: "setup-thirdBinding"
  }, {
    path: "/tutorial/details",
    component: _acd4440c,
    name: "tutorial-details"
  }, {
    path: "/user/gallery",
    component: _368841ba,
    name: "user-gallery"
  }, {
    path: "/user/xcoins",
    component: _045966f5,
    name: "user-xcoins"
  }, {
    path: "/xcoins/exchange",
    component: _154605a2,
    name: "xcoins-exchange"
  }, {
    path: "/xcoins/lottery",
    component: _cbbaae26,
    name: "xcoins-lottery"
  }, {
    path: "/xcoins/orderConfirm",
    component: _001ec91e,
    name: "xcoins-orderConfirm"
  }, {
    path: "/xcoins/xcoinRules",
    component: _3727700c,
    name: "xcoins-xcoinRules"
  }, {
    path: "/xcoins/xcoinTerms",
    component: _4c22feec,
    name: "xcoins-xcoinTerms"
  }, {
    path: "/xcoins/goods/:id?",
    component: _9307e3b6,
    name: "xcoins-goods-id"
  }, {
    path: "/xcoins/result/:id?",
    component: _46ff2854,
    name: "xcoins-result-id"
  }, {
    path: "/discussion/:id",
    component: _4038e3fc,
    name: "discussion-id"
  }, {
    path: "/gallery/:id",
    component: _2c23a8b8,
    name: "gallery-id"
  }, {
    path: "/new/:id",
    component: _78fc8f72,
    name: "new-id"
  }, {
    path: "/user/:id?",
    component: _21db855f,
    name: "user-id"
  }, {
    path: "/",
    component: _2074cbb9,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
